'use strict';
import React, { Component } from 'react';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"

class AperturaSaldoActual extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { fechasCierres, saldosCierre, pagos, consumos, cuotas, ajustes, saldosTotales } = this.props.saldosResumenes

        return <div className="container-fluid saldos-resumenes">
            <table className="table">
                <thead>
                    <tr>
                        <th>
                            <label className="label-primary">CONCEPTO</label>
                        </th>
                        <th>
                            <label className="label-primary">IMPORTE EN $</label>
                        </th>
                        <th>
                        </th>
                        <th>
                            <label className="label-primary">IMPORTE EN U$S</label>
                        </th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <label className="label-primary">Saldo Cierre <DateMask fecha={fechasCierres.FechaCierre} /></label>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={saldosCierre.SaldoCierrePesos} moneda={""} />
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={saldosCierre.SaldoCierreUsd} moneda={""} />
                        </td>
                    </tr>

                    <tr className="option-selected">
                        <td>
                            <label className="label-primary">Pagos</label>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={pagos.PagosPesos} moneda={""} />
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={pagos.PagosUsd} moneda={""} />
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <label className="label-primary">Consumos en Un Pago</label>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={consumos.ConsumosUnPagoPesos} moneda={""}/>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={consumos.ConsumosUnPagoUsd} moneda={""} />
                        </td>
                    </tr>

                    <tr className="option-selected">
                        <td>
                            <label className="label-primary">Cuotas</label>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={cuotas.CuotasPesos} moneda={""} />
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={cuotas.CuotasUsd} moneda={""} />
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <label className="label-primary">Ajustes</label>
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={ajustes.AjustesPesos} moneda={""} />
                        </td>
                        <td>
                        </td>
                        <td>
                            <MontoMask monto={ajustes.AjustesUsd} moneda={""} />
                        </td>
                    </tr>

                    <tr className="footer-table">
                        <td>
                            <label className="label-primary footer-table-text">Saldo Actual</label>
                        </td>
                        <td>
                        </td>
                        <td className="footer-table-column">
                            <MontoMask monto={saldosTotales.SaldoPesos} moneda={""} class={"footer-table-text"} />
                        </td>
                        <td>
                        </td>
                        <td className="footer-table-column">
                            <MontoMask monto={saldosTotales.SaldoUsd} moneda={""} class={"footer-table-text"} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }
}
export default AperturaSaldoActual;